import React from 'react';
import './App.css';

function App() {
  return (
    <div className="landing">
      <img 
        className="bg-image" 
        src="https://customer-assets.emergentagent.com/job_oku-logo-design/artifacts/mlz50wlc_50E326C2-0A10-401B-A7CE-071BA677D9E7.PNG" 
        alt=""
        aria-hidden="true"
      />
      <div className="overlay"></div>
      <div className="content">
        <h1 className="logo">OKU STUDIO</h1>
      </div>
      <div className="email-wrapper">
        <a href="mailto:hello@oku.studio" className="email">hello@oku.studio</a>
      </div>
    </div>
  );
}

export default App;
